
import { createContext, useState } from "react";

const ConfirmChangesContext = createContext();

export default function ConfirmChangesContextProvider({children}) {

    const [confirmEmailChange, setConfirmEmail] = useState(false);
    const [confirmRoleChange,  setConfirmRole]  = useState(false);

    return (<ConfirmChangesContext.Provider value={{confirmEmailChange, setConfirmEmail, confirmRoleChange, setConfirmRole}}>
        {children}
    </ConfirmChangesContext.Provider>);

}

export {ConfirmChangesContext};
